import { PureComponent } from 'preact-compat'
import { isChangeEvent } from '../../../libs/typeGuards'
import { LabelId, ValidationErrorId } from '../input-unit'

interface Props {
  onContentChange: (value: string) => void
  onTextareaFocus?: () => void
  adjustHeight?: boolean
  disabled?: boolean
  isControl?: boolean
  maxLength?: number
  placeholder?: string
  value?: string
  verticalResize?: boolean
}

class TextArea extends PureComponent<Props> {
  textareaElement: HTMLTextAreaElement | null = null

  constructor (props: Props) {
    super(props)
    this.adjustHeight = this.adjustHeight.bind(this)
  }

  componentDidUpdate () {
    if (this.props.adjustHeight) {
      this.adjustHeight()
    }
  }

  adjustHeight () {
    if (!this.props.adjustHeight || this.textareaElement === null) {
      return
    }
    const el = this.textareaElement
    const outerHeight = parseInt(window.getComputedStyle(el).height, 10)
    const diff = outerHeight - el.clientHeight
    el.style.height = String(el.scrollHeight + diff) + 'px'
  }

  render ({ onContentChange, onTextareaFocus, disabled, isControl, maxLength, placeholder, value, verticalResize }: Props) {
    let className = `a-text-area a-text-area--app-${isControl ? 'control' : 'destination'}`
    if (verticalResize) className += ' a-text-area--vertical-resize'

    return (
      <LabelId.Consumer>
        {(labelId) => {
          return (
            <ValidationErrorId.Consumer>
              {(validationErrorId?: string) => {
                return (
                  <textarea
                    aria-describedby={validationErrorId}
                    aria-invalid={!!validationErrorId}
                    className={className}
                    disabled={disabled}
                    id={labelId}
                    maxLength={maxLength}
                    onChange={(e) => onContentChange && isChangeEvent(e) && onContentChange((e.target).value)}
                    onClick={onTextareaFocus}
                    onInput={this.adjustHeight}
                    placeholder={placeholder}
                    ref={textarea => {
                      this.textareaElement = textarea
                    }}
                    value={value}
                  />
                )
              }}
            </ValidationErrorId.Consumer>
          )
        }}
      </LabelId.Consumer>
    )
  }
}

export default TextArea
